/**
 * MODULE: _shared/lib/frontend/api/calendarIcsFeedApi.ts
 * PURPOSE: JWT ensure/rotate for personalised iCal subscribe URL (CAL-21 / G23).
 * DEPENDENCIES: ./config (API_CONFIG, getAuthHeaders)
 * PUBLIC_API: calendarIcsFeedApi
 * AGENT_SAFETY: RESTRICTED
 * FILE_SIZE: ~55 / 150
 */

import axios from 'axios';
import { API_CONFIG, getAuthHeaders } from './config';

const base = `${API_CONFIG.baseURL}/api/v1/calendar`;

export type IcsFeedEnsureResponse = {
  token: string;
  ics_feed_tenant_id?: string | null;
};

function subscribeHttpsUrl(token: string): string {
  return `${base}/ics-feed?token=${encodeURIComponent(token)}`;
}

function subscribeWebcalUrl(token: string): string {
  return subscribeHttpsUrl(token).replace(/^https:\/\//i, 'webcal://').replace(/^http:\/\//i, 'webcal://');
}

/** Outlook on the web “subscribe from web” (HTTPS calendar URL). */
function outlookSubscribeUrl(httpsIcsUrl: string): string {
  return `https://outlook.office.com/calendar/0/addfromweb?url=${encodeURIComponent(httpsIcsUrl)}`;
}

export const calendarIcsFeedApi = {
  async ensure(): Promise<IcsFeedEnsureResponse> {
    const res = await axios.post<IcsFeedEnsureResponse>(`${base}/ics-feed/ensure`, {}, { headers: getAuthHeaders() });
    return res.data;
  },

  async rotate(): Promise<IcsFeedEnsureResponse> {
    const res = await axios.post<IcsFeedEnsureResponse>(`${base}/ics-feed/rotate`, {}, { headers: getAuthHeaders() });
    return res.data;
  },

  subscribeHttpsUrl,
  subscribeWebcalUrl,
  outlookSubscribeUrl,
};
